import { useSearchParams } from 'react-router-dom'
import { useAppState } from '../state/appState'
import { DEFAULT_SLUG } from '../lib/storage'
import { useChannel, useVods } from '../hooks/useKick'
import { ChannelHeader } from './ChannelHeader'
import { VodGrid } from './VodGrid'

export function ChannelView() {
  const [params] = useSearchParams()
  const { channels, toggleFavorite } = useAppState()
  const slug = params.get('tab') ?? channels[0]?.slug ?? DEFAULT_SLUG

  const { data: channel } = useChannel(slug)
  const { data: vods, loading, error, reload } = useVods(slug)

  const ref = channels.find((c) => c.slug === slug)

  if (!ref) {
    return (
      <div className="state-box">
        <h2>No such tab</h2>
        <p>
          The <code>{slug}</code> channel isn't open. Use <strong>+</strong> to add it.
        </p>
      </div>
    )
  }

  return (
    <>
      <ChannelHeader
        channel={channel}
        slug={slug}
        favorite={ref.favorite}
        onToggleFavorite={() => toggleFavorite(slug)}
      />
      <VodGrid vods={vods} loading={loading} error={error} onRetry={reload} />
    </>
  )
}